import React from "react";

export default function SQL_Bootcamp() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Bootcamp</h1>
      <p>This is the SQL_Bootcamp component generated from the SQL JSON.</p>
    </div>
  );
}
